import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=ec1ad586"
import script from "./ContractInfo.vue?vue&type=script&lang=js"
export * from "./ContractInfo.vue?vue&type=script&lang=js"
import style0 from "./ContractInfo.vue?vue&type=style&index=0&id=ec1ad586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports